import { FC, MutableRefObject, forwardRef, useImperativeHandle, useRef, useState } from 'react';
import V2Drawer, { V2DrawerHandles } from 'src/common/components/Feedback/V2Drawer/index';
import Edit from '.';
import { ShopEditType } from './ts-config';
import styles from './entry.module.less';
import { LngLat } from '@/common/components/Map/V2AMap';
import { useMethods } from '@lhb/hook';

/**
 * @Description 门店编辑抽屉（创建/编辑/签约场景）
 */
const ShopEditDrawer:FC<{
  reload,
  ref?,
  onClose?: () => void;
}> = forwardRef(({ reload, onClose }, ref) => {
  useImperativeHandle(ref, () => ({
    init: methods.init
  }));

  const [id, setId] = useState(null);
  const [taskId, setTaskId] = useState(null);
  const [type, setType] = useState<ShopEditType>(ShopEditType.Edit); // 当前模式，1 代表是门店编辑，2 代表是合同签约，3 创建,4 地图快速创建
  // const [tab, setTab] = useState(''); // 如果弹出框详情内有 tab，则可以设置 tab
  const [open, setOpen] = useState(false); // 弹出框是否打开
  const drawerWrapper: MutableRefObject<V2DrawerHandles | null> = useRef(null);
  const detail: any = useRef();

  const methods = useMethods({
    init({
      id,
      type = ShopEditType.Edit,
      lngLat,
      standardTaskId,
    } : {
      id: any; // 机会点id
      type: ShopEditType;
      lngLat: LngLat;
      standardTaskId: any; // 拓店任务id
    }) {
      setId(id);
      setType(type);
      setTaskId(standardTaskId);
      // tab && setTab(tab);
      setOpen(true);
      setTimeout(() => {
        drawerWrapper.current?.getBodyElement().scrollTo({ top: 0 });
        detail.current.init instanceof Function && detail.current.init(lngLat);
      }, 0);
    },
  });

  // const [container, setContainer] = useState<HTMLElement | null>(null);
  // useEffect(() => {
  //   if (open) {
  //     setTimeout(() => {
  //       const target = drawerWrapper.current?.getBodyElement();
  //       target && setContainer(target);
  //     }, 0);
  //   }
  // }, [open]);

  return (
    <V2Drawer
      style={{ height: '100%' }}
      bodyStyle={{ padding: 0, }}
      className={styles.editShopDrawer}
      forceRender
      onRef={drawerWrapper}
      open={open}
      onClose={() => {
        setOpen(false);
        onClose && onClose();
      }}
      maskClosable={false}
      push={false}>
      {open && <Edit
        editType={type}
        reload={reload}
        ref={detail}
        // container={container}
        // tab={tab}
        id={id as any}
        taskId={taskId}
        onClose={() => {
          setOpen(false);
          onClose && onClose();
        }}/>}
    </V2Drawer>
  );
});

export default ShopEditDrawer;
